/**
 * Removes the static "boot failed" overlay from index.html once the app is actually running.
 *
 * Done explicitly rather than relying on the renderer to reconcile away a DOM node it never created:
 * the overlay is `position: fixed` and covers the viewport, so if it ever survived a successful boot
 * it would black out the whole app after its 8s reveal delay. An explicit removal has no such
 * dependency on framework internals.
 */
export function clearBootFallback(): void {
  const nodes = document.querySelectorAll('.boot-fallback');
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    if (node && node.parentNode) node.parentNode.removeChild(node);
  }
}
